<template>
  <div class="sidebar__must-read-wrapper">
    <a-in-progress
      :in-progress="isSidebarContentRefreshInProgress"
      :align-spinner="$options.consts.SPINNER_ALIGNMENT.CENTER"
    >
      <must-read-with-delayed-content-refresh class="sidebar__must-read" />
    </a-in-progress>

    <a-refresh-listener
      :articles="$_sidebarRefresh_mustReadItemsForRefreshListener"
      :settings="$options.consts.AUTO_REFRESH_SETTINGS.SIDEBAR_MOST_VIEWED"
      @feed-update-required="$_sidebarRefresh_refreshSidebarContent"
    />
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { AUTO_REFRESH_SETTINGS } from 'enums/article-auto-refresh'
import AInProgress, { SPINNER_ALIGNMENT } from 'shared/AInProgress'
import ARefreshListener from 'shared/ARefreshListener'
import MustReadWithDelayedContentRefresh from '@/components/_layout/ASidebar/AMustReadWithDelayedContentRefresh/index.vue'

export default {
  name: 'SidebarMustRead',
  mixins: [mixins.sidebarRefresh],
  components: {
    MustReadWithDelayedContentRefresh,
    ARefreshListener,
    AInProgress
  },
  consts: { AUTO_REFRESH_SETTINGS, SPINNER_ALIGNMENT }
}
</script>

<style lang="scss">
.sidebar__must-read {
  margin-top: 20px;
}
</style>
